/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTariffInfo,
    JsonTariffInfoFromJSON,
    JsonTariffInfoFromJSONTyped,
    JsonTariffInfoToJSON,
} from './JsonTariffInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonTariffInfo
 */
export interface ApiResultOfJsonTariffInfo {
    /**
     * 
     * @type {JsonTariffInfo}
     * @memberof ApiResultOfJsonTariffInfo
     */
    data?: JsonTariffInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTariffInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonTariffInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTariffInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTariffInfo
     */
    result?: ApiResultOfJsonTariffInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonTariffInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonTariffInfoFromJSON(json: any): ApiResultOfJsonTariffInfo {
    return ApiResultOfJsonTariffInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonTariffInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonTariffInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonTariffInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonTariffInfoToJSON(value?: ApiResultOfJsonTariffInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonTariffInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

